<div class="{{localService.selectedLanguageCode}}"
    *ngIf="localService.languageContent && localService.languageContent.table && localService.languageContent.printer">
    <div style="max-width: 800px;" class="center banner">
        <div class="row row_header freeze_height">
            <div class="row">
                <div class="col-md-6">
                    <input autocomplete="off" type="text" [(ngModel)]="searchKey"
                        title="{{localService.languageContent.common.search}}"
                        placeholder="{{localService.languageContent.common.search}}" (input)="onFilter()" />
                </div>
                <div class="col-md-6" style="text-align: right;">
                    <label style="font-weight: normal;">
                        <input type="checkbox" [(ngModel)]="isIncludeInActive" (change)="onLoad()" />
                        <span>{{localService.languageContent.printer.showDeleted}}</span>
                    </label>
                    <button class="btn btn-primary" (click)="onAction(1)" style="margin-left: 20px;">
                        <i class="material-icons" style="color: white;top: 5px;position: relative;">add</i>
                        <span>{{localService.languageContent.common.add}}</span>
                    </button>
                </div>
            </div>
            <div class="row">
                <div class="col-12" style="text-align: left;">
                    <span
                        style="top: -8px;position: relative;left: 12px;">{{localService.languageContent.printer.printerTemplateMaps}}</span>
                </div>
            </div>
        </div>
        <div class="custom_rows_body" [ngStyle]="{'max-height' : maxBodyHeight + 'px'}">
            <div class="row styled_row" *ngFor="let item of items">
                <div class="col-11">
                    <button class="button_icon button_icon_color" (click)="onAction(2,item.Key)">
                        edit
                    </button>
                    <span style="top: -8px;position: relative;left: 12px;">{{item.Title}}</span>
                </div>
                <div class="col-1">
                    <button class="button_icon" (click)="onAction(item.IsActive ? 4 : 5,item.Key)"
                        [ngStyle]="{'color' : item.IsActive ? 'red' : 'green'}">
                        {{item.IsActive ? 'delete' : 'restore'}}
                    </button>
                </div>
            </div>
        </div>
    </div>
</div>
<div>
    <app-printer-template-map-popup [(isOpenPopup)]="isOpenTemplateMapPopup" [businessId]="businessId"
        [ctryCode]="ctryCode" (onClose)="onLoad(true)" [itemId]="selectedItemId" />
    <app-message-box *ngIf="isOpenConfirmationBox" [IsConfirmationType]="true" (onClose)="onDelete($event)"
        [IsPopup]="true" />
</div>